/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import moment from "moment";
import UsendLogo from "../../../../../../assets/img/usendlogo.png";
import { Divider, Tooltip } from "@mui/material";

export default function DisputeMessages({
  messages,
  lastMessageRef,
  disputeRow,
}) {
  useEffect(() => {
    // Scroll to the last message when messages change
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, lastMessageRef]);

  return (
    <div style={{ marginBottom: "20px" }}>
      {disputeRow && (
        <>
          <div
            style={{
              border: "1px solid #eee",
              borderRadius: "10px",
              padding: "15px",
              marginTop: "20px",
              marginLeft: "25px",
              maxWidth: "70%",
            }}
          >
            <div style={{ display: "flex" }}>
              <div>
                {disputeRow?.user?.img ? (
                  <img
                    src={disputeRow?.user?.img}
                    alt="logo"
                    style={{
                      objectFit: "cover",
                      width: "35px",
                      height: "35px",
                      marginRight: "15px",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <FaUserCircle
                    style={{
                      marginRight: "15px",
                      fontSize: "30px",
                      color: "#60717e",
                    }}
                  />
                )}
              </div>

              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <b style={{ color: "#60717e" }}>
                    {[disputeRow?.customer_name, disputeRow?.store?.store_name].filter(Boolean).join(" - ") || "You"}
                  </b>{" "}
                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#c6f1c7",
                      width: "12px",
                      height: "12px",
                      marginLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        padding: "4px",
                        borderRadius: "50%",
                        background: "#00d704",
                        width: "8px",
                        height: "8px",
                      }}
                    ></div>
                  </div>
                </div>
                <h6>
                  <strong>Dispute #{String(disputeRow?.order_number || disputeRow?.order?.shopify_order_number || "").replace(/^#/, "")}</strong> -{" "}
                  {disputeRow.issue}
                </h6>
                {disputeRow?.outcome?.length > 0 && (
                  <h6 style={{ marginBottom: "0px" }}>
                    <strong>Desired outcome</strong> :{" "}
                    {Array.isArray(disputeRow.outcome) ? disputeRow.outcome[0] : disputeRow.outcome}
                  </h6>
                )}
                {disputeRow?.tracking_id && (
                  <h6 style={{ marginBottom: "0px", lineHeight:1.5 }}>
                    <strong>Tracking ID</strong> : {disputeRow?.tracking_id}
                  </h6>
                )}
                {disputeRow?.response?.tracking_number && (
                  <h6 style={{ marginBottom: "0px", lineHeight: 1.5 }}>
                    <strong>Resend</strong> : {disputeRow.response.tracking_number}{" "}
                    <a href="/customer/orders/order-tracking" style={{ textDecoration: "underline" }}>
                      Track it
                    </a>
                  </h6>
                )}

                <h6
                  style={{
                    marginTop: "10px",
                    marginBottom: "0px",
                    lineHeight: 1.5,
                  }}
                >
                  <strong>Attachments</strong> :{" "}
                  {disputeRow.dispute_files?.length
                    ? disputeRow.dispute_files.map((item, index) => (
                        <Tooltip
                          componentsProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#ffffff",
                                boxShadow:
                                  "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.35) 0px 12px 24px -4px",
                                color: "black",
                                fontSize: "13px",
                                fontWeight: 500,
                                padding: "15px",
                                textAlign: "left",

                                maxWidth: "450px", // Set the maximum width for the tooltip
                              },
                            },
                            arrow: {
                              sx: {
                                fontSize: 16,
                                color: "#ffffff",
                              },
                            },
                          }}
                          title={
                            <img
                              src={item}
                              style={{ width: "100%", height: "100%" }} // Set the image size to 100% of the tooltip container
                              alt="receipt"
                            />
                          }
                          placement="top"
                          arrow
                        >
                          <a
                            href={item}
                            target="_blank"
                            style={{
                              marginTop: "0px",
                              marginBottom: "0px",
                              marginRight: "10px",
                              textDecoration: "underline",
                            }}
                          >
                            File {index + 1}
                          </a>
                        </Tooltip>
                      ))
                    : "N/A"}
                </h6>
                <h6 style={{ lineHeight: 1.5, marginTop: 0 }}>
                  <strong>Message</strong> :{" "}
                  {disputeRow?.message || disputeRow?.additional_notes}
                </h6>
              </div>
            </div>
          </div>
        </>
      )}
      {messages?.map((message, index) => (
        <>
          <div
            key={message.id}
            ref={index === messages.length - 1 ? lastMessageRef : null}
            style={{
              border: "1px solid #eee",
              borderRadius: "10px",
              padding: "15px",
              marginTop: "20px",
              marginLeft: message.sender === "CUSTOMER" ? "25px" : "auto",
              marginRight: message.sender !== "CUSTOMER" ? "25px" : "auto",
              maxWidth: "70%",
            }}
          >
            <div style={{ display: "flex", alignItems: "start" }}>
              <div>
                {message.sender === "CUSTOMER" ? (
                  disputeRow?.user?.img ? (
                    <img
                      src={disputeRow?.user?.img}
                      alt="logo"
                      style={{
                        objectFit: "cover",
                        width: "35px",
                        height: "35px",
                        marginRight: "15px",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <FaUserCircle
                      style={{
                        marginRight: "15px",
                        fontSize: "30px",
                        color: "#60717e",
                      }}
                    />
                  )
                ) : (
                  <img
                    src={UsendLogo}
                    alt="logo"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                      marginRight: "15px",
                    }}
                  />
                )}
              </div>

              <div>
                {message.sender === "CUSTOMER" ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <b style={{ color: "#60717e" }}>
                      {disputeRow.customer_name +
                        "-" +
                        disputeRow.store?.store_name}
                    </b>{" "}
                    <div
                      style={{
                        borderRadius: "50%",
                        background: "#c6f1c7",
                        width: "12px",
                        height: "12px",
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          padding: "4px",
                          borderRadius: "50%",
                          background: "#00d704",
                          width: "8px",
                          height: "8px",
                        }}
                      ></div>
                    </div>
                  </div>
                ) : (
                  <b style={{ color: "#60717e" }}>Team - U-Send Fulfillment</b>
                )}

                {!message?.refundDetails ? (
                  <h6 style={{ marginTop: "15px", lineHeight: 1.5 }}>
                    {message?.attachments && (
                      <>
                        {message.attachments.map((attachment) => (
                          <Tooltip
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#ffffff",
                                  boxShadow:
                                    "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.35) 0px 12px 24px -4px",
                                  color: "black",
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  padding: "15px",
                                  textAlign: "left",

                                  maxWidth: "450px", // Set the maximum width for the tooltip
                                },
                              },
                              arrow: {
                                sx: {
                                  fontSize: 16,
                                  color: "#ffffff",
                                },
                              },
                            }}
                            title={
                              <img
                                src={attachment}
                                style={{ width: "100%", height: "100%" }} // Set the image size to 100% of the tooltip container
                                alt="receipt"
                              />
                            }
                            placement="top"
                            arrow
                          >
                            <div style={{ display: "inline-block" }}>
                              <a
                                href={attachment}
                                target="_blank"
                                style={{
                                  marginTop: "0px",
                                  marginBottom: "0px",
                                  marginRight: "10px",
                                  textDecoration: "underline",
                                }}
                              >
                                attachment
                              </a>
                            </div>
                          </Tooltip>
                        ))}
                      </>
                    )}
                    <h6 style={{ lineHeight: 1.5 }}> {message.message}</h6>
                    {message.trackingId ? (
                      <h6>Resend tracking number: {message.trackingId}</h6>
                    ) : (
                      ""
                    )}
                  </h6>
                ) : (
                  <div>
                    <h6>Refund Amount Details</h6>
                    <Divider />
                    <div>
                      <h6>
                        <strong>Amount</strong>: €
                        {message.refundDetails?.amount}
                      </h6>
                      <h6>
                        <strong>Refund Type</strong>:{" "}
                        {message.refundDetails?.refundType}
                      </h6>
                      <h6>
                        <strong>Notes</strong>: {message.refundDetails?.notes}
                      </h6>
                      <h6>
                        <strong>Refunded Items Quantity</strong>:{" "}
                        {message.refundDetails?.quantity}
                      </h6>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              marginLeft: message.sender === "CUSTOMER" ? "25px" : "0px",
              marginRight: message.sender !== "CUSTOMER" ? "25px" : "0px",
              display: " flex",
              justifyContent:
                message.sender !== "CUSTOMER" ? "flex-end" : "flex-start",
            }}
          >
            <small>{moment(message.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</small>
          </div>
        </>
      ))}
    </div>
  );
}
